import { animate } from 'animejs';

const fadeIn = (modal, onComplete) => {
  if (!modal.current) return;

  animate(modal.current, {
    ease: 'linear',
    translateY: [-10, 0],
    opacity: [0, 1],
    duration: 300,
    onComplete: () => {
      onComplete?.();
    },
  });
};

const fadeOut = (modal, onComplete) => {
  if (!modal.current) return;

  animate(modal.current, {
    ease: 'linear',
    translateY: [0, 10],
    opacity: [1, 0],
    duration: 300,
    onComplete: () => {
      onComplete?.();
    },
  });
};

const slideOut = (modal, onComplete) => {
  if (!modal.current) return;

  animate(modal.current, {
    ease: 'linear',
    translateX: [0, '-100%'],
    duration: 550,
    onComplete: () => {
      onComplete?.();
    },
  });
};

export { fadeIn, fadeOut, slideOut };
